import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Music } from 'lucide-react';

const AllGenres = ({ songs }) => {
  const [genres, setGenres] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGenres = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/genres`);
        if (response.ok) {
          const data = await response.json();
          
          // Calculate song counts for each genre
          const genresWithCounts = data.map(genre => {
            const genreSongs = songs.filter(song => 
              song.genre && song.genre.toLowerCase() === genre.slug.toLowerCase()
            );
            return {
              ...genre,
              songCount: genreSongs.length
            };
          });
          
          // Ensure alphabetical order by name
          const sortedGenres = genresWithCounts.sort((a, b) => 
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          );
          
          setGenres(sortedGenres);
        }
      } catch (error) {
        console.error('Failed to fetch genres:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGenres();
  }, [songs]);

  if (loading) {
    return (
      <div className="page-content">
        <div className="page-header">
          <h1>Genres</h1>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="page-header" style={{ marginBottom: '32px' }}>
        <h1 style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '8px' }}>
          Explore Genres
        </h1>
        <p style={{ color: '#999', fontSize: '16px' }}>
          Discover music by genre • {genres.length} genres available
        </p>
      </div>

      <div className="vibes-grid">
        {genres.map(genre => (
          <Link key={genre.id} to={`/genre/${genre.slug}`} className="vibe-card">
            <div 
              className="vibe-card-background"
              style={{ 
                backgroundColor: genre.color || '#9D4EDD',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <div className="vibe-card-content" style={{ textAlign: 'center' }}>
                <Music size={48} color="white" style={{ marginBottom: '16px' }} />
                <h3 className="vibe-name">{genre.name}</h3>
                <p className="vibe-description">{genre.description || `Explore ${genre.name} music`}</p>
                <div className="vibe-song-count">{genre.songCount} songs</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AllGenres;